import * as React from 'react';
import {thinMargins} from '../../constants';
import {Button} from '../../components/common';
import {PartnerCard} from '../../types';

const cardColors = ['bodyimage', 'bluerice', 'sandwisp'];

interface IWaysToPartner {
  title?: string;
  subtitle?: string;
  items?: PartnerCard[];
}

export const WaysToPartner = ({
  title,
  subtitle,
  items = [],
}: IWaysToPartner) => {
  return (
    <div className={`${thinMargins} text-black pb-12 lg:pb-16 pt-6 lg:pt-10`}>
      <h2 className="text-h3mob md:text-h3 font-title pb-4 text-center">
        {title}
      </h2>
      {subtitle && (
        <p className="text-largebodymob md:text-largebody text-center pb-8">
          {subtitle}
        </p>
      )}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 py-4">
        {items.map((item, index) => (
          <div key={item.title} className="shrink-0 px-4">
            <div
              className={`bg-${cardColors[index % cardColors.length]} flex flex-col px-6 py-6 rounded-lg h-full gap-3`}>
              <p className="text-smallbodymob font-semibold">{item.pretitle}</p>
              <p className="text-h3mob">{item.emoji}</p>
              <h3 className="text-subtitlesmall font-title">{item.title}</h3>
              <p className="text-smallbodymob lg:text-smallbody">{item.text}</p>
              <ul className="flex flex-col gap-2 pt-2 flex-1">
                {item.benefits.map(benefit => (
                  <li
                    key={benefit}
                    className="flex items-start gap-2 text-smallbodymob lg:text-smallbody">
                    <span className="mt-[2px]">✓</span>
                    <span>{benefit}</span>
                  </li>
                ))}
              </ul>
              {item.buttonLabel && (
                <div className="pt-4">
                  <Button
                    label={item.buttonLabel}
                    type="secondary"
                    onClick={() =>
                      document
                        .getElementById(item.buttonScrollTo ?? '')
                        ?.scrollIntoView({behavior: 'smooth'})
                    }
                  />
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
